import React, { useState } from "react";
import { Form,  Button, message, Modal } from "antd";
import {  firebase } from "../../../utils";
import CountryPhoneInput from "antd-country-phone-input";
import OtpInput from "react-otp-input";

const SignIn = () => {
  const [verify, setVerify] = useState(false);
  const [otp, setOtp] = useState(0);

  const setUpRecaptcha = () => {
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      "recaptcha-container",
      {
        size: "invisible",
        callback: function (response) {
          console.log("Captcha Resolved");
          onFinish();
        },
        defaultCountry: "IN",
      }
    );
  };

  const onFinish = async (values) => {
    let phoneNumber = `+${values?.mobile?.code}${values?.mobile?.phone}`;
   await setUpRecaptcha();
    let appVerifier = window.recaptchaVerifier;
    firebase
      .auth()
      .signInWithPhoneNumber(phoneNumber, appVerifier)
      .then(function (confirmationResult) {
        window.confirmationResult = confirmationResult;
        setVerify(true)
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const onSubmitOtp = () => {
    let optConfirm = window.confirmationResult;

    optConfirm
      .confirm(otp)
      .then(function (result) {
        console.log(result);
        setVerify(false)
      })
      .catch(function (error) {
        console.log(error);
        message.error("Incorrect OTP");
      });
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "90vh",
      }}
    >
      <Modal
        title="Verify OTP"
        centered
        visible={verify}
        onOk={() => setVerify(false)}
        onCancel={() => setVerify(false)}
        footer=""
      >
        <>
          <OtpInput
            onChange={(e) => {
              setOtp(e);
            }}
            value={otp}
            inputStyle={{
              border: "1px solid gray",

              height: 50,
              width: "100%",
            }}
            containerStyle={{ height: 80 }}
            numInputs={6}
            separator={<span>-</span>}
          />

          <Form.Item>
            <Button
              type="primary"
              onClick={() => {
                onSubmitOtp();
              }}
              style={{ marginTop: 10 }}
              htmlType="submit"
              className="login-form-button"
            >
              Verify
            </Button>
          </Form.Item>
        </>
      </Modal>
    
      {/*  */}
      <Form
        name="normal_login"
        className="login-form"
        initialValues={{
          mobile: {
            short: "in",
          },
        }}
        onFinish={onFinish}
      >
          <div id="recaptcha-container"></div>
        <Form.Item
          name="mobile"
          rules={[
            {
              required: true,
              message: "Please input your mobile!",
            },
          ]}
        >
          <CountryPhoneInput placeholder="Enter your mobile" />
          {/* <Input
            prefix={<PhoneOutlined className="site-form-item-icon" />}
            placeholder="Enter your mobile"
          /> */}
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            Log in
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
export default SignIn;
